import { Spacing } from '../../design-system/spacing';
import { styled } from '../../utils/styled';
import { Box } from '../Box';
import { Typography } from '../Typography';

export const StyledBox = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isChipButton',
})<{ isChipButton?: boolean }>`
  display: flex;
  gap: ${({ theme }) => theme.spacing(Spacing.Small)};
  align-items: center;
  margin-left: ${({ theme, isChipButton }) =>
    isChipButton && theme.spacing(Spacing.Medium)};
  margin-right: ${({ theme, isChipButton }) =>
    isChipButton && theme.spacing(Spacing.Medium)};
`;

export const StyledTypography = styled(Typography, {
  shouldForwardProp: (prop) => prop !== 'bold',
})<{ bold?: boolean }>`
  text-transform: capitalize;
  font-weight: ${({ bold }) => (bold ? 'bold' : 'normal')};
`;
